import React, { useState, useEffect } from 'react';
import { Box, Button, Typography } from '@mui/material';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import GradientColorPicker, { useColorPicker } from 'react-best-gradient-color-picker';
import tc from 'tinycolor2';

interface ColorPickerProps {
  label?: string;
  color?: string;
  onChange?: (color: string) => void;
}

export const ColorPicker = ({ label, color = '#000000', onChange = () => {} }: ColorPickerProps) => {
  const [visibleColorPicker, setVisibleColorPicker] = useState<boolean>(false);
  const [gradientColor, setGradientColor] = useState(color);
  const { valueToHex } = useColorPicker(gradientColor, setGradientColor);
  const supportsEyeDropper = typeof window !== 'undefined' && 'EyeDropper' in window;

  useEffect(() => {
    setGradientColor(color);
  }, [color]);

  const handleChange = (newColor: string) => {
    if (newColor.includes('gradient')) {
      onChange(newColor);
      return;
    }

    onChange(tc(newColor).toHexString());
  };

  const hexColor = valueToHex();

  return (
    <Box>
      {label && (
        <Typography variant="caption" color="text.secondary">
          {label}
        </Typography>
      )}

      <ClickAwayListener onClickAway={() => setVisibleColorPicker(false)}>
        <Box>
          <Button
            variant="outlined"
            onClick={() => setVisibleColorPicker(!visibleColorPicker)}
            sx={{ width: 140, paddingX: 2 }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', width: '100%' }}>
              <Box sx={{ width: 16, height: 16, bgcolor: hexColor, borderRadius: 0.5, marginRight: 1.5 }} />
              <Typography color="textSecondary">{hexColor}</Typography>
            </Box>
          </Button>

          <Box
            sx={{
              display: visibleColorPicker ? 'block' : 'none',
              position: 'absolute',
              zIndex: 1,
              marginTop: 0.5,
              marginLeft: 0.4,
            }}
          >
            <GradientColorPicker
              value={gradientColor}
              onChange={handleChange}
              hideEyeDrop={!supportsEyeDropper}
              height={140}
              style={{ body: { padding: '8px' } }}
              hideColorTypeBtns
            />
          </Box>
        </Box>
      </ClickAwayListener>
    </Box>
  );
};
